import script from "./trade-request.vue?vue&type=script&setup=true&lang=js"
export * from "./trade-request.vue?vue&type=script&setup=true&lang=js"

import "./trade-request.vue?vue&type=style&index=0&id=15cdf2b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cdf2b3"]])

export default __exports__